import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'

const TwChangesHistoryHint = tw.div`
  leading-6
  text-14
  text-obscure-old
  cursor-default
  mr-auto
`

export const ChangesHistoryHint = () => (
  <TwChangesHistoryHint>{Lang.msg.changesHistoryHint}</TwChangesHistoryHint>
)
